// extracted by mini-css-extract-plugin
export default {"container":"DashboardLayout_container__R8SUr","childrenContainer":"DashboardLayout_childrenContainer__+RmZY"};